import React, { useRef, useState, useEffect } from "react";
import defaultReference from "../assets/resume/KnackHook_ResumeFormat.docx"
import axios from "axios";
import * as pdfjsLib from "pdfjs-dist/webpack";
import mammoth from "mammoth";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { GenerateContent } from "../apiconstants/constants";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
  import { saveAs } from "file-saver";
import htmlDocx from "html-docx-js/dist/html-docx";
pdfjsLib.GlobalWorkerOptions.workerSrc =
  `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;




export default function ResumeFormatter() {
const [referenceText, setReferenceText] = useState("");
const [referenceFileName, setReferenceFileName] = useState("default-reference.docx"); // ✅ default name
  const [originalText, setOriginalText] = useState("");
  const [formattedResume, setFormattedResume] = useState("");
  const [loading, setLoading] = useState(false);

  // Read PDF
  const readPdfFile = async (file, setTextState) => {
    const fileReader = new FileReader();
    fileReader.onload = async function () {
      const typedarray = new Uint8Array(this.result);
      const pdf = await pdfjsLib.getDocument(typedarray).promise;
      let text = "";
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join(" ");
        text += pageText + "\n";
      }
      setTextState(text);
    };
    fileReader.readAsArrayBuffer(file);
  };

  // Read DOCX
  const readDocxFile = async (file, setTextState) => {
    const fileReader = new FileReader();
    fileReader.onload = async function (event) {
      const arrayBuffer = event.target.result;
      const result = await mammoth.extractRawText({ arrayBuffer });
      setTextState(result.value); // plain text
    };
    fileReader.readAsArrayBuffer(file);
  };

const handleFileUpload = (e, setTextState, setFileName) => {
  const file = e.target.files[0];
  if (!file) return;

  setFileName(file.name); // ✅ update displayed file name

  if (file.type === "application/pdf") {
    readPdfFile(file, setTextState);
  } else if (
    file.type ===
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ) {
    readDocxFile(file, setTextState);
  } else {
    alert("Please upload a PDF or DOCX file.");
  }
};
useEffect(() => {
    const loadDefaultReference = async () => {
      try {
        const response = await fetch(defaultReference);
        const blob = await response.blob();
        const file = new File([blob], "default-reference.docx", {
          type: blob.type,
        });

        if (file.type === "application/pdf") {
          await readPdfFile(file, setReferenceText);
        } else if (
          file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ) {
          await readDocxFile(file, setReferenceText);
        }
      } catch (error) {
        console.error("Error loading default reference resume:", error);
      }
    };

    loadDefaultReference();
  }, []);
const handleFormat = async () => {
  if (!referenceText || !originalText) {
    alert("Please upload both resumes first.");
    return;
  }
  setLoading(true);
  const token = localStorage.getItem('jwtToken');

  try {
    const response = await axios.post(
      GenerateContent.APIURL,
      {
        prompt: `You are an expert resume formatting engine.

Given:
1. A **Reference Resume** which defines the structure, section order, and alignment style.
2. An **Original Resume** which contains the actual candidate's content.

Formatting Rules:
- Follow the exact structure, section order, and alignment of the Reference Resume.
- Replace placeholders with the candidate’s actual content from the Original Resume.
- If a section exists in the Reference Resume but not in the Original Resume, SKIP it (do not leave blanks).

Styling Requirements:
⚠️ CRITICAL RULES (must never be broken):
- **Do not omit or shorten ANY content** from the Original Resume. Every sentence, bullet, and point must appear in the final output, even if formatting changes.
- If a section exists in the Reference Resume but not in the Original Resume, SKIP it (do not leave blanks).
- Use a **NARROW single-column layout **.

Styling Requirements:
Formatting Guidelines:
- Layout: Narrow, professional, single column.
- Font: Calibri, 11pt.
- Header (Name, Email, Phone, LinkedIn): Center-aligned.
- Sections in order: Summary, Education, Certificates, Skill Sets, Work Experience.
- Work Experience format:
   - Company (bold)
   - Client (bold)
   - Role (italic or bold)
   - Duration (bold, right-aligned so it appears on the opposite side of role/client)
1. **Summary Section**: Convert into bullet points (<ul><li>...</li></ul>).
2. **Key Skills**: Highlight by making them bold (<b>Skill</b>) or styled clearly so they stand out.
3. **Experience Section**:
   - Company names → **bold**
   - Client names → **bold**
   - Period of work (dates) → **bold, right aligned**
   - Job titles → italic or bold
   - "Description", "Responsibilities", and "Environment" → must be **bold labels**
   - Ensure there is **one line gap** between each experience entry for readability.
4. Correct any **spelling mistakes** automatically.
5. Maintain professional inline CSS formatting for spacing, margins, and alignment.
6. Final output must be in clean HTML (renderable in webpage/Word/PDF).

### Reference Resume:
${referenceText}

### Original Resume:
${originalText}

### Output Format:
Return ONLY the final formatted resume in HTML with inline CSS that matches the alignment and layout of the reference resume.`
      },
      {
        headers: {
          "Content-Type": "application/json",
          "accept": "*/*",
          "Authorization": `Bearer ${token}`
        }
      }
    );

    console.log("API Response:", response);

    let formattedHtml =
      response.data?.response?.candidates[0]?.content?.parts?.[0]?.text || "";
if (formattedHtml.startsWith("```html")) {
  formattedHtml = formattedHtml.replace(/^```html\s*/i, "");
}
if (formattedHtml.endsWith("```")) {
  formattedHtml = formattedHtml.replace(/```$/i, "");
}

setFormattedResume(formattedHtml.trim());
    setFormattedResume(formattedHtml);

  } catch (err) {
    console.error(err);
    alert("Error formatting resume");
  }
  setLoading(false);
};
  const printRef = useRef();
const name = localStorage.getItem('firstName')
const handleDownloadPdf = async () => {
  const element = printRef.current;
  const canvas = await html2canvas(element, { scale: 1.5 });
  const imgData = canvas.toDataURL("image/png");

  const pdf = new jsPDF("p", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const marginX = 10; // left/right padding in mm
  const marginY = 10; // top/bottom padding in mm
  const pageGap = 20; // ✅ extra gap between pages in mm

  const imgWidth = pageWidth - marginX * 2;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = marginY;

  // First page
  pdf.addImage(imgData, "PNG", marginX, position, imgWidth, imgHeight);
  heightLeft -= (pageHeight - marginY * 2);

  // Extra pages with gap
  while (heightLeft > 0) {
    position = -(imgHeight - heightLeft) + marginY + pageGap; // ✅ add gap
    pdf.addPage();
    pdf.addImage(imgData, "PNG", marginX, position, imgWidth, imgHeight);
    heightLeft -= (pageHeight - marginY * 2);
  }

  // Save PDF
  const pdfBlob = pdf.output("blob");
  const url = URL.createObjectURL(pdfBlob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "formatted_resume.pdf";
  link.click();
  URL.revokeObjectURL(url);
};

  const handleDownloadWord = () => {
  if (!formattedResume) {
    alert("No resume to download!");
    return;
  }

  // Wrap in <html><body> so Word opens it properly
  const htmlContent = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8" />
      </head>
      <body>
        ${formattedResume}
      </body>
    </html>
  `;

  // Convert HTML → Word blob
  const blob = htmlDocx.asBlob(htmlContent);

  // Save as .docx
  saveAs(blob, "formatted_resume.docx");
};
  return (
    <ConsultantLayout>
    <div style={{ padding: "20px" }}>
      <h2 className="" style={{ color: "#00a7ac", marginLeft: '10px' }}>AI Resume Formatter</h2>
  <hr />
    <div>
  
  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
   <h5 style={{ color: "#00a7ac" }}>Upload Reference Resume (PDF or DOCX):</h5>
  <input  className="form-control"
      type="file"
      accept=".pdf, .docx"
      onChange={(e) =>
        handleFileUpload(e, setReferenceText, setReferenceFileName)
            }
              style={{ marginBottom: "10px", height:'38px',width: '250px' }}
    />
    {/* ✅ Always show either default or uploaded filename */}
    <span style={{ fontStyle: "italic", color: "#333" }}>
      {referenceFileName}
    </span>
  </div>
</div>



     <div>

  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
       <h5 style={{ color: "#00a7ac" }}>Upload Original Resume (PDF or DOCX):</h5>
    <input className="form-control"
      type="file"
      accept=".pdf, .docx"
      onChange={(e) => handleFileUpload(e, setOriginalText, () => {})}
       style={{ marginBottom: "10px", height:'38px',width: '250px' }}
    />
    {/* Show message if no file uploaded */}
    <span style={{ fontStyle: "italic", color: "#999" }}>
      {originalText ? "Uploaded" : "No file chosen"}
    </span>
  </div>
</div>

      <button className="btn btn-primary"
        style={{
          marginTop: "15px",
          padding: "10px 15px",
          background: "#00a7ac",
          color: "#fff",
        }}
        onClick={handleFormat}
        disabled={loading}
      >
        {loading ? "Formatting..." : "Format Resume"}
      </button>

  <div style={{ marginTop: "20px"}}>


  {/* <button
    onClick={handleDownloadPdf}
    disabled={!formattedResume}
    className="btn btn-primary mb-3"
    style={{ backgroundColor: "#00a7ac", border: "none", float:"right", margin:8 }}
  >
    Download as PDF
  </button> */}

  <button
    onClick={handleDownloadWord}
    disabled={!formattedResume}
    className="btn btn-primary mt-5"
    style={{ backgroundColor: "#0056b3", border: "none", float: "right", margin: 8 }}
  >
    Download as Word
  </button>

{formattedResume && (
  <>
    <h3>Formatted Resume Output</h3>
    <div
      style={{ display: "flex", justifyContent: "center" }}
    >
      <div
        ref={printRef}
        style={{
          background: "#fff",
          padding: "20px",
          border: "1px solid #ccc",
          maxWidth: "650px",   // ✅ only the resume is narrow
          width: "100%",
        }}
        dangerouslySetInnerHTML={{ __html: formattedResume }}
      />
    </div>
  </>
)}
 
</div>

    </div>
    </ConsultantLayout>
  );
}
